import React from 'react';

// OneBotAds editorial design system — scoped under .obhome so it never leaks into the app.
// Palette: navy-black #0F0B2D / #16122E surfaces · periwinkle accent #818CF8 (#4F46E5 on light) · light #F6F7FB
const EditorialTheme = () => (
  <style>{`
    .obhome { font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
    .obhome h1, .obhome h2, .obhome h3, .obhome h4 { font-family: 'Space Grotesk', -apple-system, sans-serif; }
    .obhome .serif-accent { font-family: 'Instrument Serif', Georgia, serif; font-style: italic; font-weight: 400; letter-spacing: -0.01em; }
    .obhome .mono-label { font-family: 'Space Mono', 'Consolas', monospace; font-size: 11px; letter-spacing: 0.16em; text-transform: uppercase; font-weight: 400; }
  `}</style>
);

export default EditorialTheme;
